const expiresInDays = 365;

const setCookie = ({ cname, cvalue, exdays, secure = false, domain = "" }: any) => {
  const d = new Date();
  if (!exdays) exdays = expiresInDays;
  d.setTime(d.getTime() + exdays * 1000 * 60 * 60 * 24);
  // @ts-ignore
  const expires = `expires=${d.toGMTString()}`;
  let cookieString = `${cname}=${cvalue}; ${expires}; path=/;`;
  if (secure) {
    cookieString += ` Secure;`;
  }
  if (domain) {
    cookieString += ` domain=${domain};`;
  }
  window.document.cookie = cookieString;
};
export default setCookie;

type CookieOptions = {
  cname: string;
  cvalue: string;
  exdays?: number;
  secure?: boolean;
  domain?: string;
};

export const setAppCookies = (cookies: CookieOptions[]) => {
  cookies.forEach((cookie) => setCookie(cookie));
};
